/* ber-main-product.js — fully scoped, Dawn-independent PDP controller */
(function () {
  'use strict';

  function cartAddUrl() {
    if (window.routes && window.routes.cart_add_url) return window.routes.cart_add_url;
    var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return root.replace(/\/?$/, '/') + 'cart/add.js';
  }

  function addToCartRequest(variantId, quantity, btn, textEl, onSuccess) {
    if (!variantId) return;
    if (btn) btn.dataset.berState = 'loading';
    if (textEl) textEl.textContent = 'Adding…';

    var formData = new FormData();
    formData.append('id', variantId);
    formData.append('quantity', quantity || 1);

    var cartDrawer = document.querySelector('cart-drawer');
    if (cartDrawer && typeof cartDrawer.getSectionsToRender === 'function') {
      formData.append(
        'sections',
        cartDrawer.getSectionsToRender().map(function (section) {
          return section.id;
        })
      );
      formData.append('sections_url', window.location.pathname);
      if (typeof cartDrawer.setActiveElement === 'function') cartDrawer.setActiveElement(btn || document.activeElement);
    }

    fetch(cartAddUrl(), {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }
    })
      .then(function (res) {
        return res.json().then(function (data) {
          return { ok: res.ok, data: data };
        });
      })
      .then(function (result) {
        if (!result.ok) {
          if (btn) btn.dataset.berState = 'error';
          if (textEl) textEl.textContent = result.data && result.data.description ? result.data.description : 'Try Again';
          setTimeout(function () {
            if (btn) btn.dataset.berState = 'available';
            if (textEl) textEl.textContent = 'Add to Cart';
          }, 2400);
          return;
        }
        if (btn) btn.dataset.berState = 'added';
        if (textEl) textEl.textContent = 'Added';

        if (cartDrawer && result.data && result.data.sections && typeof cartDrawer.renderContents === 'function') {
          cartDrawer.classList.remove('is-empty');
          cartDrawer.renderContents(result.data);
        }

        document.dispatchEvent(
          new CustomEvent('ber:cart:updated', {
            detail: { item: result.data },
            bubbles: true
          })
        );

        if (
          typeof publish === 'function' &&
          typeof PUB_SUB_EVENTS !== 'undefined' &&
          PUB_SUB_EVENTS.cartUpdate
        ) {
          publish(PUB_SUB_EVENTS.cartUpdate, {
            source: 'ber-main-product',
            productVariantId: variantId,
            cartData: result.data
          });
        }

        if (typeof onSuccess === 'function') onSuccess(result.data);
        setTimeout(function () {
          if (btn) btn.dataset.berState = 'available';
          if (textEl) textEl.textContent = 'Add to Cart';
        }, 1800);
      })
      .catch(function () {
        if (btn) btn.dataset.berState = 'error';
        if (textEl) textEl.textContent = 'Try Again';
        setTimeout(function () {
          if (btn) btn.dataset.berState = 'available';
          if (textEl) textEl.textContent = 'Add to Cart';
        }, 2400);
      });
  }

  function viewerIcon(path) {
    return '<svg viewBox="0 0 24 24" aria-hidden="true" focusable="false"><path d="' + path + '" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"></path></svg>';
  }

  function createMediaViewer(root, imageNodes) {
    var images = Array.prototype.slice.call(imageNodes || []);
    if (!images.length) return function () {};

    var viewer = document.createElement('div');
    viewer.className = 'ber-pdp__zoom';
    viewer.hidden = true;
    viewer.setAttribute('role', 'dialog');
    viewer.setAttribute('aria-modal', 'true');
    viewer.setAttribute('aria-hidden', 'true');
    viewer.setAttribute('aria-label', 'Product image viewer');

    var close = document.createElement('button');
    close.type = 'button';
    close.className = 'ber-pdp__zoom-close';
    close.setAttribute('aria-label', 'Close image viewer');
    close.innerHTML = viewerIcon('M6 6l12 12M18 6 6 18');

    var stage = document.createElement('div');
    stage.className = 'ber-pdp__zoom-stage';

    var figure = document.createElement('figure');
    figure.className = 'ber-pdp__zoom-figure';

    var image = document.createElement('img');
    image.className = 'ber-pdp__zoom-img';
    image.alt = '';
    image.draggable = false;

    var caption = document.createElement('figcaption');
    caption.className = 'ber-pdp__zoom-caption';
    caption.setAttribute('aria-live', 'polite');

    var previous = document.createElement('button');
    previous.type = 'button';
    previous.className = 'ber-pdp__zoom-nav ber-pdp__zoom-nav--prev';
    previous.setAttribute('aria-label', 'Previous product image');
    previous.innerHTML = viewerIcon('M15 5 8 12l7 7');

    var next = document.createElement('button');
    next.type = 'button';
    next.className = 'ber-pdp__zoom-nav ber-pdp__zoom-nav--next';
    next.setAttribute('aria-label', 'Next product image');
    next.innerHTML = viewerIcon('m9 5 7 7-7 7');

    figure.appendChild(image);
    figure.appendChild(caption);
    stage.appendChild(figure);
    stage.appendChild(previous);
    stage.appendChild(next);
    viewer.appendChild(close);
    viewer.appendChild(stage);
    document.body.appendChild(viewer);

    var multiple = images.length > 1;
    previous.hidden = !multiple;
    next.hidden = !multiple;

    var computed = window.getComputedStyle(root);
    viewer.style.setProperty('--ber-pdp-ui-font', computed.fontFamily || 'system-ui, sans-serif');
    viewer.style.setProperty('--ber-pdp-accent-color', computed.getPropertyValue('--ber-pdp-accent-color') || '#b89a67');

    var index = 0;
    var trigger = null;
    var touchX = null;
    var openState = false;
    var pageLocked = false;
    var htmlOverflow = '';
    var bodyOverflow = '';
    var bodyPaddingRight = '';

    function sourceFor(sourceImage) {
      return sourceImage.dataset.berZoomSrc || sourceImage.currentSrc || sourceImage.src;
    }

    function render(nextIndex) {
      index = (nextIndex + images.length) % images.length;
      var sourceImage = images[index];
      viewer.classList.add('ber-pdp__zoom--loading');
      image.alt = sourceImage.alt || '';
      image.src = sourceFor(sourceImage);
      caption.textContent = multiple ? index + 1 + ' / ' + images.length : '';

      if (image.complete) {
        window.requestAnimationFrame(function () {
          viewer.classList.remove('ber-pdp__zoom--loading');
        });
      }
    }

    function lockPage() {
      if (pageLocked) return;
      pageLocked = true;
      htmlOverflow = document.documentElement.style.overflow;
      bodyOverflow = document.body.style.overflow;
      bodyPaddingRight = document.body.style.paddingRight;

      var scrollbarWidth = Math.max(0, window.innerWidth - document.documentElement.clientWidth);
      if (scrollbarWidth > 0) {
        var currentPadding = parseFloat(window.getComputedStyle(document.body).paddingRight) || 0;
        document.body.style.paddingRight = currentPadding + scrollbarWidth + 'px';
      }

      document.documentElement.classList.add('ber-pdp-lock-scroll');
      document.body.classList.add('ber-pdp-lock-scroll');
      document.documentElement.style.overflow = 'hidden';
      document.body.style.overflow = 'hidden';
    }

    function unlockPage() {
      if (!pageLocked) return;
      pageLocked = false;
      document.documentElement.classList.remove('ber-pdp-lock-scroll');
      document.body.classList.remove('ber-pdp-lock-scroll');
      document.documentElement.style.overflow = htmlOverflow;
      document.body.style.overflow = bodyOverflow;
      document.body.style.paddingRight = bodyPaddingRight;
    }

    function open(sourceImage) {
      if (openState) return;
      openState = true;
      trigger = document.activeElement;
      var selected = images.indexOf(sourceImage);

      render(selected > -1 ? selected : 0);
      viewer.hidden = false;
      viewer.setAttribute('aria-hidden', 'false');
      lockPage();

      window.requestAnimationFrame(function () {
        viewer.classList.add('ber-pdp__zoom--open');
        try {
          close.focus({ preventScroll: true });
        } catch (error) {
          close.focus();
        }
      });
    }

    function shut(restoreFocus) {
      if (!openState) return;
      openState = false;

      try {
        viewer.classList.remove('ber-pdp__zoom--open', 'ber-pdp__zoom--loading');
        viewer.hidden = true;
        viewer.setAttribute('aria-hidden', 'true');
        image.removeAttribute('src');
      } finally {
        unlockPage();
      }

      if (restoreFocus !== false && trigger && typeof trigger.focus === 'function' && document.contains(trigger)) {
        try {
          trigger.focus({ preventScroll: true });
        } catch (error) {
          trigger.focus();
        }
      }
      trigger = null;
    }

    function focusable() {
      return Array.prototype.slice.call(
        viewer.querySelectorAll('button:not([hidden]):not(:disabled), [href], [tabindex]:not([tabindex="-1"])')
      ).filter(function (element) {
        return element.offsetParent !== null;
      });
    }

    function onKeydown(event) {
      if (!openState) return;

      if (event.key === 'Escape') {
        event.preventDefault();
        shut();
        return;
      }
      if (event.key === 'ArrowLeft' && multiple) {
        event.preventDefault();
        render(index - 1);
        return;
      }
      if (event.key === 'ArrowRight' && multiple) {
        event.preventDefault();
        render(index + 1);
        return;
      }
      if (event.key !== 'Tab') return;

      var items = focusable();
      if (!items.length) return;
      var first = items[0];
      var last = items[items.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    function emergencyUnlock() {
      if (openState) shut(false);
      else unlockPage();
    }

    images.forEach(function (sourceImage, sourceIndex) {
      if (!sourceImage.hasAttribute('tabindex')) sourceImage.tabIndex = 0;
      sourceImage.setAttribute('role', 'button');
      sourceImage.setAttribute('aria-label', 'Open product image ' + (sourceIndex + 1) + ' of ' + images.length);
      sourceImage.addEventListener('click', function (event) {
        event.preventDefault();
        open(sourceImage);
      });
      sourceImage.addEventListener('keydown', function (event) {
        if (event.key !== 'Enter' && event.key !== ' ') return;
        event.preventDefault();
        open(sourceImage);
      });
    });

    image.addEventListener('load', function () {
      viewer.classList.remove('ber-pdp__zoom--loading');
    });
    image.addEventListener('error', function () {
      viewer.classList.remove('ber-pdp__zoom--loading');
    });
    close.addEventListener('click', function () {
      shut();
    });
    previous.addEventListener('click', function () {
      render(index - 1);
    });
    next.addEventListener('click', function () {
      render(index + 1);
    });
    viewer.addEventListener('click', function (event) {
      if (event.target === viewer || event.target === stage) shut();
    });
    viewer.addEventListener('touchstart', function (event) {
      if (event.touches.length === 1) touchX = event.touches[0].clientX;
    }, { passive: true });
    viewer.addEventListener('touchend', function (event) {
      if (touchX === null || !event.changedTouches.length || !multiple) return;
      var delta = event.changedTouches[0].clientX - touchX;
      touchX = null;
      if (Math.abs(delta) >= 45) render(delta > 0 ? index - 1 : index + 1);
    }, { passive: true });

    document.addEventListener('keydown', onKeydown);
    window.addEventListener('pagehide', emergencyUnlock);
    window.addEventListener('pageshow', emergencyUnlock);

    return function () {
      document.removeEventListener('keydown', onKeydown);
      window.removeEventListener('pagehide', emergencyUnlock);
      window.removeEventListener('pageshow', emergencyUnlock);
      emergencyUnlock();
      viewer.remove();
    };
  }

  function initBerPdp(root) {
    if (root.dataset.berPdpInit === 'true') return;
    root.dataset.berPdpInit = 'true';

    var variantsEl = root.querySelector('[data-ber-pdp-variants]');
    var variants = [];
    if (variantsEl) {
      try {
        variants = JSON.parse(variantsEl.textContent);
      } catch (e) {
        variants = [];
      }
    }

    var optionEls = root.querySelectorAll('[data-ber-option-value]');
    var form = root.querySelector('form.ber-pdp__form');
    var variantIdInput = root.querySelector('[data-ber-variant-id]');
    var priceEl = root.querySelector('[data-ber-price]');
    var comparePriceEl = root.querySelector('[data-ber-compare-price]');
    var saveBadgeEl = root.querySelector('[data-ber-save-badge]');
    var addBtn = root.querySelector('[data-ber-add-btn]');
    var addText = root.querySelector('[data-ber-add-text]');
    var variantMetaEl = root.querySelector('[data-ber-variant-meta]');
    var variantTitleEl = root.querySelector('[data-ber-variant-title]');
    var stickyPriceEl = root.querySelector('[data-ber-sticky-price]');
    var stickyVariantEl = root.querySelector('[data-ber-sticky-variant]');

    function displayableVariantLabel(label) {
      var value = String(label || '').trim();
      var normalized = value.toLowerCase();
      var inspiredBy = String(root.dataset.berInspiredBy || '').trim().toLowerCase();

      if (
        !value ||
        normalized === 'default title' ||
        normalized.indexOf('inspired by') !== -1 ||
        (inspiredBy && normalized === inspiredBy)
      ) {
        return '';
      }

      return value;
    }

    var selections = [];
    var currentVariantId = variantIdInput ? variantIdInput.value : null;
    var currentVariant = variants.filter(function (v) {
      return String(v.id) === String(currentVariantId);
    })[0];
    if (currentVariant) selections = currentVariant.options.slice();

    function findMatch(sel) {
      return variants.filter(function (v) {
        return v.options.every(function (o, i) {
          return o === sel[i];
        });
      })[0];
    }

    function optionAvailable(index, value) {
      var testSel = selections.slice();
      testSel[index] = value;
      return variants.some(function (v) {
        return v.options.every(function (o, i) {
          if (i === index) return o === value;
          return o === testSel[i];
        });
      });
    }

    function render() {
      var match = findMatch(selections);

      optionEls.forEach(function (btn) {
        var idx = parseInt(btn.dataset.optionIndex, 10);
        var val = btn.dataset.value;
        var isSelected = selections[idx] === val;
        btn.classList.toggle('ber-pdp__option-btn--selected', isSelected);
        btn.setAttribute('aria-pressed', isSelected ? 'true' : 'false');
        var avail = optionAvailable(idx, val);
        btn.classList.toggle('ber-pdp__option-btn--unavailable', !avail);
      });

      if (!match) {
        if (addBtn) {
          addBtn.disabled = true;
          addBtn.dataset.berState = 'unavailable';
        }
        if (addText) addText.textContent = 'Unavailable';
        return;
      }

      if (variantIdInput) variantIdInput.value = match.id;
      if (priceEl) priceEl.textContent = match.price;
      if (stickyPriceEl) stickyPriceEl.textContent = match.price;
      var variantLabel = displayableVariantLabel(match.title);
      if (variantTitleEl) variantTitleEl.textContent = variantLabel;
      if (variantMetaEl) variantMetaEl.hidden = !variantLabel;
      if (stickyVariantEl) {
        var stickyLabel = variantLabel || displayableVariantLabel(root.dataset.berSizeDisplay);
        stickyVariantEl.textContent = stickyLabel;
        stickyVariantEl.hidden = !stickyLabel;
      }

      if (comparePriceEl) {
        if (match.compare_at_price) {
          comparePriceEl.textContent = match.compare_at_price;
          comparePriceEl.hidden = false;
        } else {
          comparePriceEl.hidden = true;
        }
      }

      if (saveBadgeEl) {
        if (match.compare_at_price && match.compare_at_price_raw > match.price_raw && match.price_raw > 0) {
          var pct = Math.round((1 - match.price_raw / match.compare_at_price_raw) * 100);
          saveBadgeEl.textContent = 'SAVE ' + pct + '%';
          saveBadgeEl.hidden = false;
        } else {
          saveBadgeEl.hidden = true;
        }
      }

      if (addBtn) {
        addBtn.disabled = !match.available;
        addBtn.dataset.berState = match.available ? 'available' : 'soldout';
      }
      if (addText) addText.textContent = match.available ? 'Add to Cart' : 'Sold Out';

      if (window.history && window.history.replaceState) {
        try {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', match.id);
          window.history.replaceState({}, '', url);
        } catch (e) {
          /* no-op: URL API unsupported */
        }
      }

      if (match.featured_media_id) jumpToMedia(match.featured_media_id);
    }

    optionEls.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.classList.contains('ber-pdp__option-btn--unavailable')) return;
        var idx = parseInt(btn.dataset.optionIndex, 10);
        selections[idx] = btn.dataset.value;
        render();
      });
    });

    render();

    /* ── Add to cart ──────────────────────────────────────────────────── */
    /* Only intercept submits from our own Add to Cart button. Dynamic
       checkout buttons (Shop Pay, PayPal, etc.) rendered by `payment_button`
       manage their own click/submit flow and must reach checkout natively —
       intercepting them here would silently break accelerated checkout. */
    if (form) {
      form.addEventListener('submit', function (e) {
        if (addBtn && e.submitter && e.submitter !== addBtn) return;
        e.preventDefault();
        if (!addBtn || addBtn.disabled) return;
        var qtyInput = root.querySelector('[data-ber-qty-input]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        addToCartRequest(variantIdInput ? variantIdInput.value : null, qty, addBtn, addText);
      });
    }

    /* ── Quantity stepper ─────────────────────────────────────────────── */
    var qtyInputEl = root.querySelector('[data-ber-qty-input]');
    var qtyMinus = root.querySelector('[data-ber-qty-minus]');
    var qtyPlus = root.querySelector('[data-ber-qty-plus]');
    if (qtyInputEl && qtyMinus && qtyPlus) {
      qtyMinus.addEventListener('click', function () {
        var v = Math.max(1, (parseInt(qtyInputEl.value, 10) || 1) - 1);
        qtyInputEl.value = v;
      });
      qtyPlus.addEventListener('click', function () {
        var v = (parseInt(qtyInputEl.value, 10) || 1) + 1;
        qtyInputEl.value = v;
      });
    }

    /* ── Gallery ──────────────────────────────────────────────────────── */
    var thumbs = root.querySelectorAll('[data-ber-thumb]');
    var slides = root.querySelectorAll('[data-ber-slide]');
    var track = root.querySelector('[data-ber-track]');
    var counter = root.querySelector('[data-ber-counter]');
    var dots = root.querySelectorAll('[data-ber-dot]');
    var prevBtn = root.querySelector('[data-ber-prev]');
    var nextBtn = root.querySelector('[data-ber-next]');
    var activeIndex = 0;
    var isScrollSync = false;

    function goToSlide(i, opts) {
      opts = opts || {};
      if (!slides.length) return;
      activeIndex = Math.max(0, Math.min(slides.length - 1, i));
      slides.forEach(function (s, idx) {
        s.classList.toggle('ber-pdp__slide--active', idx === activeIndex);
      });
      thumbs.forEach(function (t, idx) {
        t.classList.toggle('ber-pdp__thumb--active', idx === activeIndex);
        t.setAttribute('aria-pressed', idx === activeIndex ? 'true' : 'false');
      });
      dots.forEach(function (d, idx) {
        d.classList.toggle('ber-pdp__dot--active', idx === activeIndex);
      });
      if (counter) counter.textContent = activeIndex + 1 + ' / ' + slides.length;

      if (!opts.fromScroll && track) {
        var target = slides[activeIndex];
        if (target && window.innerWidth <= 767) {
          isScrollSync = true;
          track.scrollTo({ left: target.offsetLeft, behavior: opts.instant ? 'auto' : 'smooth' });
          setTimeout(function () {
            isScrollSync = false;
          }, 400);
        }
      }
    }

    thumbs.forEach(function (t, idx) {
      t.addEventListener('click', function () {
        goToSlide(idx);
      });
    });
    if (prevBtn) prevBtn.addEventListener('click', function () { goToSlide(activeIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function () { goToSlide(activeIndex + 1); });
    dots.forEach(function (d, idx) {
      d.addEventListener('click', function () { goToSlide(idx); });
    });

    if (track) {
      var scrollTimer;
      track.addEventListener(
        'scroll',
        function () {
          if (isScrollSync) return;
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var idx = Math.round(track.scrollLeft / track.clientWidth);
            if (idx !== activeIndex) goToSlide(idx, { fromScroll: true });
          }, 100);
        },
        { passive: true }
      );
    }

    function jumpToMedia(mediaId) {
      var idx = -1;
      slides.forEach(function (s, i) {
        if (String(s.dataset.mediaId) === String(mediaId)) idx = i;
      });
      if (idx > -1) goToSlide(idx, { instant: true });
    }

    /* ── Body-level media viewer ──────────────────────────────────────── */
    var zoomable = root.querySelectorAll('[data-ber-zoomable]');
    root.berPdpViewerCleanup = createMediaViewer(root, zoomable);

    /* ── Accordions ───────────────────────────────────────────────────── */
    var accTriggers = root.querySelectorAll('[data-ber-accordion-trigger]');
    accTriggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var expanded = trigger.getAttribute('aria-expanded') === 'true';
        var panel = document.getElementById(trigger.getAttribute('aria-controls'));
        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        if (panel) {
          panel.dataset.open = expanded ? 'false' : 'true';
          if (expanded) {
            panel.setAttribute('inert', '');
          } else {
            panel.removeAttribute('inert');
          }
        }
      });
    });

    /* ── Inspired-by tooltip ──────────────────────────────────────────── */
    var tooltipBtn = root.querySelector('[data-ber-tooltip]');
    if (tooltipBtn) {
      var tooltipPanel = document.getElementById(tooltipBtn.getAttribute('aria-describedby'));
      tooltipBtn.addEventListener('click', function (e) {
        e.stopPropagation();
        if (!tooltipPanel) return;
        tooltipPanel.hidden = !tooltipPanel.hidden;
      });
      document.addEventListener('click', function (e) {
        if (tooltipPanel && !tooltipPanel.hidden && !tooltipBtn.contains(e.target) && !tooltipPanel.contains(e.target)) {
          tooltipPanel.hidden = true;
        }
      });
    }

    /* ── Sticky mobile / desktop bar ──────────────────────────────────── */
    var stickyBar = root.querySelector('[data-ber-sticky-bar]');
    var sentinel = root.querySelector('[data-ber-cta-sentinel]');
    var mobileEnabled = root.dataset.mobileStickyEnabled === 'true';
    var desktopEnabled = root.dataset.desktopStickyEnabled === 'true';

    if (stickyBar && sentinel && (mobileEnabled || desktopEnabled) && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var isMobile = window.innerWidth < 768;
            var shouldShow = !entry.isIntersecting && ((isMobile && mobileEnabled) || (!isMobile && desktopEnabled));
            stickyBar.classList.toggle('ber-pdp__sticky-bar--visible', shouldShow);
          });
        },
        { threshold: 0 }
      );
      io.observe(sentinel);
      window.addEventListener('resize', function () {
        var isMobile = window.innerWidth < 768;
        if ((isMobile && !mobileEnabled) || (!isMobile && !desktopEnabled)) {
          stickyBar.classList.remove('ber-pdp__sticky-bar--visible');
        }
      });
    }

    var stickyAddBtn = root.querySelector('[data-ber-sticky-add]');
    if (stickyAddBtn) {
      stickyAddBtn.addEventListener('click', function () {
        if (!addBtn || addBtn.disabled) return;
        var qtyInput = root.querySelector('[data-ber-qty-input]');
        var qty = qtyInput ? parseInt(qtyInput.value, 10) || 1 : 1;
        addToCartRequest(variantIdInput ? variantIdInput.value : null, qty, addBtn, addText);
      });
    }

    /* ── Upsell quick add ─────────────────────────────────────────────── */
    var upsellBtns = root.querySelectorAll('[data-ber-upsell-add]');
    upsellBtns.forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.disabled) return;
        var originalText = btn.textContent;
        btn.disabled = true;
        btn.textContent = 'Adding…';
        addToCartRequest(btn.dataset.variantId, 1, null, null, function () {
          btn.textContent = 'Added';
          setTimeout(function () {
            btn.textContent = originalText;
            btn.disabled = false;
          }, 1600);
        });
      });
    });
  }

  function initAll() {
    document.querySelectorAll('[data-ber-pdp]').forEach(initBerPdp);
  }

  document.addEventListener('DOMContentLoaded', initAll);
  document.addEventListener('shopify:section:load', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-ber-pdp]') : null;
    if (root) {
      root.dataset.berPdpInit = 'false';
      initBerPdp(root);
    }
  });
  document.addEventListener('shopify:section:unload', function (e) {
    var root = e.target && e.target.querySelector ? e.target.querySelector('[data-ber-pdp]') : null;
    if (root && typeof root.berPdpViewerCleanup === 'function') {
      root.berPdpViewerCleanup();
      root.berPdpViewerCleanup = null;
    }
  });
  if (document.readyState !== 'loading') initAll();
})();
